import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
} from "@mui/material";
import "../campaigns/Campaigns.scss";
import CloseIcon from '../../assets/icons/close-icon-black.svg';

interface DialogDeleteProps {
    open: boolean;
    onClose: () => void;
    onDelete: () => void;
    name: string;
    status: string;
    id?: string | number | null;
}

const DialogDelete = ({
    open,
    onClose,
    onDelete,
    id,
    name,
    status,

  }: DialogDeleteProps) => {

    return (
        <Dialog open={open} onClose={onClose} className="general-dialog">
            <DialogTitle className="custom-dialog-title">
                <div className="view-all-attributes__title">Delete campaign</div>
                <img className='close-icon' src={CloseIcon} alt='close icon' onClick={onClose} />
            </DialogTitle>
            <DialogContent className="dialog-download">
                <div className='dataset-sec'>
                    <div className='view-all-attributes__dataset-wrapper__label'>You are about to delete the campaign <b>{name}</b>.</div>
                </div>
            </DialogContent>
            <DialogActions>
                <button type="button" className="btn-border" onClick={onClose}>
                    Cancel
                </button>
                <button type="button" className="btn-primary" onClick={onDelete}>
                    Delete
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogDelete;